'use client'

import { setCookie, deleteCookie } from 'cookies-next'
import { useCallback, useEffect } from 'react'

import {
  isNilOrEmptyString,
  useSession,
  onIdTokenChanged,
  firebaseSignOut,
} from '@/shared/lib'
import { FIREBASE_COOKIE } from '@/shared/lib/server'

export const FirebaseProvider = () => {
  const session = useSession()

  const firebaseToken = session?.data?.firebaseToken

  const initializeFirebase = useCallback(async () => {
    if (isNilOrEmptyString(firebaseToken)) {
      await firebaseSignOut()

      return
    }
  }, [firebaseToken])

  useEffect(() => {
    void initializeFirebase()
  }, [initializeFirebase])

  useEffect(() => {
    return onIdTokenChanged(async user => {
      if (user) {
        const idToken = await user.getIdToken()
        await setCookie(FIREBASE_COOKIE, idToken)
      } else {
        await deleteCookie(FIREBASE_COOKIE)
      }
    })
  }, [])

  return null
}
